import Vue from 'vue';
import store from '../../store';
import addressTypeTransformer from '../../transformers/addressType';

const success = ({ data }, resolve) => {
  const addressTypes = addressTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchaddressTypes', addressTypes);
  resolve();
};

const failed = () => {
};

// Display clientAddress types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('address_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/addressType/all.js